<template>
  <article>
    <group>
      <x-input
        title="服务项目"
        :required=true
        placeholder="请选择服务项目"
        :readonly=true
        @click.native="onShowServices"
        :value="serviceName"
        @on-vali="afterValidate"
        is-link
      ></x-input>
      <x-input
        :required="true"
        :readonly="true"
        :value="currentSelected.value"
        :is-type="validateAppointmentTime"
        title="预约分配"
        placeholder="请选择预约分配"
        is-link
        @click.native="showTimeSelectPopup = true"
        @on-vali="afterValidate"
      ></x-input>
    </group>
    <group :gutter="mt10">
      <x-input
        title="车牌号码"
        :is-type="validatePlateNumber"
        placeholder="粤A12345"
        :readonly="true"
        @click.native="showPlateNumberPopup = true"
        v-model="appointment.plate_number"
        @on-vali="afterValidate"
        is-link
      ></x-input>
      <x-input
        title='车架号码'
        @on-vali="afterValidate"
        :is-type="validateVin"
        :max="17"
        placeholder="车架号码"
        :readonly="true"
        @click.native="showVinPopup = true"
        v-model="appointment.vin"
        is-link
      ></x-input>
      <x-input
        title='车型'
        :max="30"
        placeholder="车型"
        v-model.trim="appointment.car_model"
      ></x-input>
      <x-input title="当前里程" @on-vali="afterValidate" :is-type="validateMileage" placeholder="请输入公里数" v-model.number="appointment.mileage">
        <span slot="right">公里</span>
      </x-input>
    </group>
    <group :gutter="mt10">
      <x-input title="联系人 "  @on-vali="afterValidate" :is-type="validateName" placeholder="您的姓名" v-model="appointment.contact_name"></x-input>
      <x-input
        title='手机号码'
        type="tel"
        @on-vali="afterValidate"
        :is-type="validateMobile"
        :max="11"
        placeholder="手机号码"
        v-model="appointment.contact_number"
      ></x-input>
    </group>
    <group>
      <x-input
        title="跟进人"
        placeholder="请选择跟进人"
        :readonly=true
        @click.native="onShowServiceConsultants"
        v-model="appointment.consultant.name"
        @on-vali="afterValidate"
        is-link
      ></x-input>
      <x-input
        title="其他标识"
        :max="30"
        placeholder="（选填）如发动机号"
        v-model="appointment.other_mark"
      ></x-input>
    </group>
    <group title="备注文字（选填）">
      <x-textarea :max="200" v-model="appointment.remark" placeholder="请输入100字以内的车辆情况描述" :show-counter="false"></x-textarea>
    </group>
    <section class="appointment-btn-bottom">
      <x-button @click.native="onSubmit" class="appointment-btn-fix" :class="{active: !error}" type="primary">
        <div>
          提交预约
        </div>
      </x-button>
    </section>
    <!-- 服务项目弹层 -->
    <popup v-model="showServicePopup" style="height: 100%;overflow: auto;">
      <group title="服务项目">
        <checklist
          v-model="appointment.service_ids"
          label-position="left"
          :options="services"
          @on-change="handleServicesChange"
        />
      </group>
      <x-button @click.native="handleCloseService">确定</x-button>
    </popup>
    <!-- 车牌弹层 -->
    <PlateNumberOrVinPopup
      placeholder="请输入车牌号码"
      :isShowPopup="showPlateNumberPopup"
      :searchVal="appointment.plate_number"
      :valMaxLen="7"
      :queryType="2"
      @on-item="(item) => handleSelectPlateNumberOrVin(item, 'showPlateNumberPopup')"
      @on-confirm="(val) => handleConfirmPlateNumberOrVin(val, 'plate_number', 'showPlateNumberPopup')"
    />
    <!-- 车架号弹层 -->
    <PlateNumberOrVinPopup
      placeholder="请输入车架号"
      :isShowPopup="showVinPopup"
      :searchVal="appointment.vin"
      :valMaxLen="17"
      :queryType="3"
      @on-item="(item) => handleSelectPlateNumberOrVin(item, 'showVinPopup')"
      @on-confirm="(val) => handleConfirmPlateNumberOrVin(val,  'vin', 'showVinPopup')"
    />
    <!-- 接待人弹层 -->
    <popup v-model="showServiceConstantPopup" style="height: 100%;overflow: auto;">
      <group title="接待人">
        <checker v-model="appointment.consultant_id">
          <checker-item class="appointment-item" v-for="item in service_consultants" :key="item.id" :value="item.id" @on-item-click="onSelectServiceConsultants">
            <cell class="appointment-adviser">
              <!--<img slot="icon" class="appointment-adviser-img" :src="item.logo_url"></img>-->
              <span slot="after-title" class="appointment-title">{{item.name}}</span>
              <icon type="success_no_circle" v-if="item.id === appointment.consultant.id"></icon>
            </cell>
          </checker-item>
        </checker>
      </group>
    </popup>
    <TimeSettingPopup
      v-model="showTimeSelectPopup"
      :selectedInfo="currentSelected"
      :cb="timeSettingCb"
    ></TimeSettingPopup>
    <Confirm
      title="提示"
      cancelText="查看预约" confirmText="返回修改"
      v-model="repeatWarnInfo.show"
      @on-cancel="handleShowDetail"
      @on-confirm="repeatWarnInfo.show = false"
    >
      <p class="confirm-text">{{ repeatWarnInfo.content }}</p>
    </Confirm>
    <Confirm
      title="提示"
      cancelText="继续" confirmText="取消"
      v-model="pendingBookingInfo.show"
      @on-cancel="handleConfirmPendingBooking"
      @on-confirm="pendingBookingInfo.show = false"
    >
      <div class="confirm-text" v-html="pendingBookingInfo.content"></div>
    </Confirm>
  </article>
</template>

<script>
import {
  Group,
  Cell,
  XInput,
  XTextarea,
  Checker,
  CheckerItem,
  Checklist,
  XButton,
  Popup,
  Icon,
  Confirm
  // XDialog
} from '@lx-frontend/cvux'
import TimeSettingPopup from './TimeSettingPopup'
import PlateNumberOrVinPopup from './PlateNumberOrVinPopup'
import util from '../../common/util'

export default {
  components: {
    Group,
    Cell,
    XInput,
    XTextarea,
    Checker,
    CheckerItem,
    Checklist,
    XButton,
    Popup,
    Icon,
    Confirm,
    TimeSettingPopup,
    PlateNumberOrVinPopup
  },
  data() {
    return {
      mt10: '0.13333333rem',
      timeError: false,
      serviceName: '',
      appointment: {
        channel: {},
        service: {
          name: ''
        }, // 服务类型
        receiver: {
          name: '',
          id: ''
        }, // 服务顾问
        consultant: {
          name: '',
          id: ''
        },
        appointed_time: '', // 预计到店
        plate_number: '', // 车牌号码
        car_model: '', // 车型
        mileage: '', // 当前里程
        contact_name: '', // 联系人
        contact_number: '', // 手机号码
        other_mark: '', // 其他标识
        remark: '' // 备注
      },
      fields: ['service_ids', 'appointed_time', 'plate_number', 'vin', 'mileage', 'contact_name', 'contact_number', 'other_mark', 'remark', 'receiver_id', 'car_model'],
      form: {
        service_ids: [], // 服务类型id
        appointed_time: '', // 预计到店
        plate_number: '', // 车牌号码
        vin: '', // 车架号
        mileage: '', // 当前里程
        contact_name: '', // 联系人
        contact_number: '', // 手机号码
        receiver_id: 0, // 接待人id
        consultant_id: 0, // 服务顾问id
        other_mark: '', // 其他标识
        remark: '', // 备注
        check_pending_booking: true // 检查待处理预约
      },
      validStatus: {}, // 表单校验状态
      showServicePopup: false, // 服务类别
      showReceiverPopup: false, // 服务顾问列表
      showServiceConstantPopup: false, // 接待人列表
      showPlateNumberPopup: false, // 车牌
      showVinPopup: false, // 车架号
      showContactNumberPopup: false, // 手机号
      // showDialog: false, // 展示成功对话框
      error: null, // 校验结果
      services: [], // 服务类别列表
      service_consultants: [],
      isClicked: false,
      showTimeSelectPopup: false,
      repeatWarnInfo: { // 重复预约警告信息
        show: false,
        content: '',
        id: '' // 预约id
      },
      pendingBookingInfo: {
        show: false,
        content: ''
      },
      queryForm: { // 查询预约所需参数
        page: 1,
        count: 10,
        plate_number: '',
        time: 'all', // 时间范围 all 表示全部 / today 表示今日 默认为全部
        is_confirmed: '' // 筛选是否确认的预约 true 已经确认 / false 未确认 为空时表示不筛选 注意类型为string
      },
      timer: null,
      contactNumberList: [],
      plateNumberList: [],
      vinList: [],
      defaultServices: {},
      isSetDefaultServiceId: false,
      currentSelected: {
        date: '',
        time: '',
        consultant_id: -1,
        consultant_display: '',
        value: ''
      }
    }
  },
  mounted() {
    this.$store.state.promiseAuth.then(data => {
      this.form.consultant_id = data.id
      this.appointment.consultant_id = data.id
      this.appointment.consultant.id = data.id
      this.appointment.consultant.name = data.userName
    })
    this.getConsultants()
    this.appointment.plate_number = this.$route.query.plate_number || ''
    this.$rest.appointment.getServices().then(res => {
      if (res.code === 0) {
        this.services = res.data.services
        const defaultServices = res.data.services.find(item => item.is_default === 1)
        if (!defaultServices) {
          return
        }
        this.serviceName = defaultServices.name
        this.defaultServices = defaultServices
      }
    })
  },
  onUnload() {
    clearTimeout(this.timer)
  },
  methods: {
    handleServicesChange(ids) {
      const curIds = ids.map(id => +id)
      // 服务展示
      this.serviceName = this.services
        .filter(item => curIds.indexOf(+item.key) >= 0)
        .map(item => item.value).join('、')
      // 设置表单值
      this.appointment.service_ids = curIds
    },
    validateDate(value) {
      if (value) {
        this.timeError = true
        this.showToast('预约时间必填')
      } else {
        this.timeError = false
      }
    },
    validatePlateNumber(val) {
      let valid = util.regexpMap.car_plate_number.test(val)
      return this.validate(val, valid, '请输入有效的车牌号，如\'粤B12345\'')
    },
    validateVin(val) {
      let valid = util.regexpMap.regexp_car_vin.test(val)
      return this.validate(val, valid, '请输入有效的车架号')
    },
    validateMileage(val) {
      let valid = util.regexpMap.regexp_car_mileage.test(val)
      return this.validate(val, valid, '请输入有效的里程')
    },
    validateName(val) {
      let valid = util.regexpMap.regexp_name_cn.test(val) || util.regexpMap.regexp_name_en.test(val)
      return this.validate(val, valid, '请输入有效的联系人名字')
    },
    validateMobile(val) {
      let valid = util.regexpMap.regexp_mobile.test(val)
      return this.validate(val, valid, '请输入有效的电话号码')
    },
    validateAppointmentTime() {
      return {
        valid: !!this.appointment.appointed_time,
        msg: '预约时间必填'
      }
    },
    validate(val, valid, msg) {
      // let validStatus = {}
      // if (valid) {
      //   validStatus.valid = true
      //   validStatus.msg = ''
      // } else {
      //   validStatus.valid = false
      //   validStatus.msg = msg
      // }
      return { valid, msg }
    },
    // 校验不通过时展示提示信息
    afterValidate(errors, valid, uuid) {
      // 将校验信息放进hash map 中
      // let msg = errors.format || errors.required
      let msg = Object.values(errors).pop()
      let validStatus = this.validStatus
      validStatus[uuid] = validStatus.uuid || {}
      validStatus[uuid].valid = valid
      validStatus[uuid].msg = msg
      // 获取一个错误的表单项
      this.error = this.getError()
      // if (this.error && this.error.msg) {
      // this.showToast(this.error.msg)
      // }
    },
    handleCloseService() {
      this.showServicePopup = false
    },
    onSelectServiceConsultants(id) {
      this.showServiceConstantPopup = false
      // 服务展示
      this.appointment.consultant = this.service_consultants.find(val => {
        return id === val.id
      })
      if (id === 0) this.appointment.consultant = { name: '' }
      // 设置表单值
      this.form.consultant_id = id
    },
    onShowServices() {
      this.$rest.appointment.getServices().then((res) => {
        if (res.code === 0) {
          if (!this.isSetDefaultServiceId) {
            this.appointment.service_ids = [this.defaultServices.id]
            this.isSetDefaultServiceId = true
          }
          this.services = res.data.services.map(v => ({
            key: v.id + '',
            value: v.name
          }))
          this.showServicePopup = true
        } else {
          this.showToast('系统繁忙，请稍候再试！！')
        }
      })
    },
    getError() {
      let validStatus = this.validStatus
      return Object.values(validStatus).find(v => {
        return !v.valid
      })
    },
    async getConsultants() {
      const { code, data, message } = await this.$rest.appointment.getConsultants()
      if (code !== 0) {
        this.showToast(message)
        return
      }
      this.service_consultants = [...data.service_consultants]
    },
    timeSettingCb(item) {
      const { date, time, consultant_id } = item
      this.appointment.appointed_time = date + ' ' + time
      this.appointment.receiver_id = consultant_id
      this.currentSelected = { ...item }
      this.showTimeSelectPopup = false
    },
    async onSubmit() {
      let error = this.getError()
      if (!error) {
        if (this.timeError) {
          this.showToast('预约时间必填')
        } else {
          this.fields.forEach(v => {
            if (this.appointment[v]) {
              this.form[v] = this.appointment[v]
            }
          })
          if (!this.isSetDefaultServiceId && this.appointment.service_ids.length === 0) {
            this.form.service_ids = [this.defaultServices.id]
          }
          if (!(this.form.plate_number || this.form.vin)) {
            this.showToast('车牌号或车架号至少填写一项')
            return
          }
          // this.form.appointed_time = this.form.appointed_time.trim() + ':00'
          if (this.isClicked) {
            return false
          }
          this.isClicked = true
          this.form = {
            ...this.form,
            service_ids: this.form.service_ids.filter(item => item !== null)
          }
          // 数字类型的公里数为选填填，故而需要特殊处理一下
          if (!this.form.mileage) {
            delete this.form.mileage
          }
          if (!this.form.receiver_id || this.form.receiver_id === -1) delete this.form.receiver_id
          const res = await this.$rest.appointment.addAppointment(this.form)
          if (res.code === 0) {
            this.$router.push('/appointment/suc')
          } else if (res.code === 1021) {
            const lines = (res.data || []).map(item => `${item.receiver_display}已提交车辆预约，预约时间为${item.appointed_date}`)
            const content = `<span class="confirm-content">已存在预约是否继续提交？</span><br><div style="max-height:200px;overflow-y:auto">${lines.join('<br>')}</div>`
            this.pendingBookingInfo.content = content
            this.pendingBookingInfo.show = true
            this.isClicked = false
            return
          } else {
            this.showToast(res.message)
          }
          this.form.check_pending_booking = true
          this.isClicked = false
        }
      } else {
        if (error.msg) {
          this.isClicked = false
          this.showToast(error.msg)
        }
      }
    },
    handleShowDetail() {
      this.$router.push(`/appointment/detail/${this.repeatWarnInfo.id}`)
    },
    handleConfirmPendingBooking() {
      this.pendingBookingInfo.show = false
      this.form.check_pending_booking = false
      this.onSubmit()
    },
    handleSelectContactNumber(item) {
      this.showContactNumberPopup = false
      const { contact_name: contactName, contact_number: contactNumber, plate_number: plateNumber } = item
      this.appointment.contact_name = contactName
      this.appointment.contact_number = contactNumber
      this.appointment.plate_number = plateNumber
    },
    handleSelectPlateNumberOrVin(item, showTypePopup) {
      this[showTypePopup] = false
      const { contact_name: contactName, contact_number: contactNumber, plate_number: plateNumber, vin, model_desc } = item
      this.appointment.contact_name = contactName
      this.appointment.contact_number = contactNumber
      this.appointment.plate_number = plateNumber
      this.appointment.vin = vin
      this.appointment.car_model = model_desc
      if (item.consultant) {
        this.appointment.receiver_id = item.consultant.id
        this.currentSelected.consultant_id = item.consultant.id
        this.currentSelected.consultant_display = item.consultant.name
        this.currentSelected.value = `${this.appointment.appointed_time || '请选择预约时间'} ${item.consultant.name}`
      }
    },
    handleConfirmPlateNumberOrVin(val, keyField, showTypePopup) {
      this.appointment[keyField] = val
      this[showTypePopup] = false
    },
    handleConfirmContactNumber() {
      this.showContactNumberPopup = false
    },
    onShowServiceConsultants() {
      if (this.service_consultants.length <= 0) {
        this.$rest.appointment.getReceivers().then((res) => {
          if (res.code === 0) {
            this.service_consultants = res.data.receivers
            this.showServiceConstantPopup = true
          } else {
            this.showToast('系统繁忙，请稍候再试！！')
          }
        })
      } else {
        this.showServiceConstantPopup = true
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../../stylesheets/base/fn";
.confirm-content {
  font-size:28/@w2;
}
.adviser-img {
  display: block;
  width: 96/@w2;
  height: 96/@w2;
  border-radius: 50%;
}

.appointment-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appointment-advisor-right {
  color: #b8b8b8;
}

.appointment-item {
  width: 100%;
}

.appointment-adviser-img {
  display: block;
  width: 60/@w2;
  height: 60/@w2;
}
.appointment-adviser:after {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  border-top: 1px solid #D9D9D9;
  color: #D9D9D9;
  margin-left: 30/@w2;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}
.appointment-btn-bottom {
  position: relative;
  z-index: 10;
  padding-top: 58/@w;
  .appointment-btn-fix {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    font-size: 30/@w2;
    height: 96/@w2;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-box;
    display: box;
    border-radius: 0px;
    color: #948d8d;
    background-color: #ccc;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    box-align: center;
    justify-content: center;
    align-items: center;
    &.active {
      background: #3b5999;
      color: #fff;
    }
  }
  .appointment-btn-fix:after{
    border-radius: 0px;
    border: none;
  }
}
</style>
